import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { UsuarioModule } from '../modelo/usuario/usuario.module';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(private http: HttpClient) { }


  listarUsuario(){
    return this.http.get(environment.apiUrlMaxipan+"usuario.php"); 
  }


  guardar(listaUsuario:UsuarioModule){
    console.log(environment.apiUrlMaxipan+"usuario.php",JSON.stringify(listaUsuario));
    return this.http.post(environment.apiUrlMaxipan+"usuario.php",JSON.stringify(listaUsuario)); 
  }

  eliminar(id:number){
  //  console.log(environment.apiUrlMaxipan+"usuario.php",JSON.stringify(listaUsuario));
    return this.http.get(environment.apiUrlMaxipan+"usuario.php?idD="+id); 
  }

}
